import { createRoutine } from 'redux-saga-routines';
import { takeLatest, call, put, select } from 'redux-saga/effects';
import { get } from 'lodash/fp';
import queryString from 'query-string';
import { AnyAction } from 'redux';
import { IHelpArticleListsResponse, IActionPayloadgetHelpArticleListsContent } from '../helpers/types';
import api, { CMS_API_HOST, API_HOST } from '../helpers/api';

const getHelpArticle = createRoutine('help/GET_HELP_ARTICLE');
const resetHelpPageError = createRoutine('help/RESET_HELP_ERROR');
const getHelpArticleListsContent = createRoutine('help/GET_HELP_ARTICAL_LISTS_PAGE_CONTENT');
const clearHelpArticle = createRoutine('help/CLEAR_HELP_ARTICLE');

function* handlegetHelpArticleListsContent({ payload }: AnyAction) {
  const { helpType, slug, locale, isLoggedIn }: IActionPayloadgetHelpArticleListsContent = payload;

  const url = `${API_HOST}/help/${helpType}/${slug}/?language=${locale}&isLoggedIn=${!!isLoggedIn}`;
  // @ts-expect-error fix type for yield
  const user = yield select(get('user.data'));
  try {
    yield put(getHelpArticleListsContent.request());
    const response: IHelpArticleListsResponse = yield call(api.get, url, !!user);
    yield put(getHelpArticleListsContent.success({ locale, helpType, slug, response, isLoggedIn }));
  } catch (error) {
    yield put(getHelpArticleListsContent.failure(error));
  } finally {
    yield put(getHelpArticleListsContent.fulfill());
  }
}

function* handleGetHelpArticle({ payload: slug }: AnyAction) {
  try {
    // @ts-expect-error fix type for yield
    const locale = yield select(get('intl.locale'));
    // @ts-expect-error fix type for yield
    const search = yield select(get('router.location.search'));
    const { revisionId } = queryString.parse(search);
    const searchParams = queryString.stringify({ language: locale, revision_id: revisionId });
    yield put(getHelpArticle.request());
    // @ts-expect-error fix type for yield
    const response = yield call(api.get, `${CMS_API_HOST}/help/articles/${slug}/?${searchParams}`);
    const articles = { [slug]: response };
    yield put(getHelpArticle.success({ locale, articles }));
  } catch (error) {
    yield put(getHelpArticle.failure(error));
  } finally {
    yield put(getHelpArticle.fulfill());
  }
}

function* helpSaga() {
  yield takeLatest(getHelpArticle.TRIGGER, handleGetHelpArticle);
  yield takeLatest(getHelpArticleListsContent.TRIGGER, handlegetHelpArticleListsContent);
}

export { getHelpArticleListsContent, getHelpArticle, resetHelpPageError, clearHelpArticle, helpSaga };
